<template>
  <div>
    <span v-bind="$attrs" v-on="$listeners">
      <template v-if="mode === 'svg'">
        <svg class="icon">
          <use :xlink:href="`#icon-${type}`"></use>
        </svg>
      </template>
      <template v-else><i class="icon iconfont" :class="type"></i></template
    ></span>
  </div>
</template>

<script>
export default {
  name: "Icon",
  props: {
    mode: {
      type: String,
      default: "svg", // icon | svg
    },
    type: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
